import { render } from "./QuestionsTickChoice.vue?vue&type=template&id=7b65700d"
import script from "./QuestionsTickChoice.vue?vue&type=script&lang=js"
export * from "./QuestionsTickChoice.vue?vue&type=script&lang=js"

import "./QuestionsTickChoice.vue?vue&type=style&index=0&id=7b65700d&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__